import { NavItems } from '@shared/Frontend/components/navItems'
import { AsyncState, Template, Unit, unit } from 'ballerina-core'
import React, { ReactNode } from 'react'
import { NavigationTemplate } from '../navigation/navigation.template'
import { CMSMenuState } from './cmsMenu.state'

export type CMSMenuView = {
  CMSMenu: (_: { items: NavItems }) => ReactNode
}

export const CMSMenuTemplate = Template.Default<Unit, CMSMenuState, Unit, CMSMenuView>(
  ({ context, setState, view }) => (
    <>
      <NavigationTemplate
        context={{ ...context, slug: 'main' }}
        setState={setState}
        foreignMutations={unit}
        view={unit}
      />
      {AsyncState.Operations.hasValue(context) && context.value && <view.CMSMenu items={context.value} />}
    </>
  )
)
